define('specific/header/views/HeaderView', [
    'specific/header/templates/header'
], function(tpl) {

    var HeaderView = Mazarine.View.extend({

        events: {
            "click .maz-header-back": "onClickBackMazHeader"
        },

        template: tpl,

        className: "maz-header-view",

        render: function() {
            var options = {
                back: this.model.get('datas').back,
                mainLogoLink: this.model.get('datas').mainLogoLink,
                mainLogoSrc: this.model.get('datas').mainLogoSrc
            };

            this.$el.html(this.template(options));
            return this.$el;

        },

        onClickBackMazHeader: function(e) {

            e.preventDefault();

            var referrer = document.referrer;
            console.log(referrer);
            if ( referrer.indexOf('dior') > -1 ) {
                console.log('##redirect referer');
                window.location.href = referrer;
            } else {
                console.log('##redirect custom url', this.model.get('datas').customUrlBack);
                window.location.href = this.model.get('datas').customUrlBack;
            }

        }

    });

    return HeaderView;
});
